<div class="widget-content">
  <div *ngIf="!loading && (!cashBalanceChartData || cashBalanceChartData.datasets === undefined || cashBalanceChartData.datasets?.length == 0)" class="arrears-chart-no-data-message">
    <h4>No data to display</h4>
  </div>
  <div [hidden]="!cashBalanceChartData || cashBalanceChartData.datasets === undefined || cashBalanceChartData.datasets?.length == 0" class="chart-container">
    <canvas #chartCanvas></canvas>
  </div>
</div>
